let $api: { (message: string, params?: { [key: string]: any }): string };

$api = (service: string, params?: { [key: string]: any }): string => {
  const services: { [service: string]: any } = {
    login: "login",
    logout: "logout",
    registration_juristical: "auth/registration/juristical",
    registration_pyhsical: "auth/registration/pyhsical",
    verify_user: "auth/registration/verify-user",
    reset_password: "auth/reset-password-email",
    resend_otp: "auth/resend-otp/",
    // user: "users",
    countries: "get-countries",
    country_details: "country-details",
    notifications: "get-all-notifications",
    notifications_id: "read-single-notification/{clientId}/{id}",
    notifications_read_all: "read-all",
    faq: "get-faq",
    dangerous_goods: "prohibited-items",
    sellers: "get-seller",
    tariffs: "get-tariffs",
    store_category: "store-category",
    get_packages: "packages",
    calculator: "calculator/amount-calculate",
    cities: "get-cities",
    regions: "courier/get-area",
    package: "courier/get-packages",
    delivery_time:
      "courier/delivery-payment-types?area_id=14&courier_payment_type=2",
    post_courier: "courier/create-courier-order",
    get_allOrders: "courier/order",
    get_wolt_calculated_price: "/wolt/calculate",
    order_wolt: "/wolt/create-order",
    get_all_orders_wolt: "/wolt/orders",
    get_all_order_details_wolt: "/wolt/order-details",
    geo_autocomplete: "/wolt/geo/autocomplete",
    geo_reverse: "/wolt/geo/reverse",
    get_courierSetting: "courier/get-settings",
    get_azerpoctRegions: "courier/azerpost/regions",
    get_regionByIndex: "courier/azerpost/postindex/{regionId}",
    getAzerpoctOrders: "courier/azerpost/",
    post_AzerpoctOrders: "courier/azerpost/create-order",
    change_password: "auth/reset-password/{otp_session}",
    get_myAccount: "/get-user",
    edit_userProfie: "/user/update-details",
    get_TrendyolOtpCode: "/trendyol-otp",
    get_AzerpostOrder: "courier/azerpost/",
    get_AmazonOtp: "seller-otp/",
    post_AmazonOtp: "seller-otp/create-otp",
    edit_AmazonOtp: "seller-otp/update-otp",
    get_ReferalAccount: "referal",
    package_history: "packages/history",
    pay_packages: "packages/package-bulk-pay",
    orders_sellers: "orders/seller",
    orders_categories: "packages/category",
    orders_currency: "orders/currency",
    upload_invoice: "packages/update/{id}",
    post_Newreferal: "referal/add-new-referal",
    payment_types: "courier/payment-types",
    post_calculatedelivery_courier: "courier/calculate",
    post_azerpoct_delivery: "courier/azerpost/calculate",
    get_balanceHistory: "balance/operations",
    add_referal: "referal/add-referal",
    redirect_referal_account: "referal/redirect-referal-account",
    balance: "balance",
    get_calculatorDeliveryType: "calculator",
    get_balance: "balance",
    post_balance: "balance/add",
    balance_direct_pay: "balance/direct-pay",
    get_packagesUpdate: "packages/update/{id}",
    get_packesBaku: "orders/baku",
    get_packesonTheway: "orders/sent",
    get_packesWareHouse: "orders/warehouse",
    get_packesDelivered: "orders/delivered",
    get_packeagesType: "packages/package-type",
    get_Promocode: "promocode",
    post_Promocode: "promocode/create-promocode",
    get_Attornery: "attorney",
    post_Attornery: "attorney/create-attorney",
    Edit_Attornery: "attorney/update-attorney/{id}",
    Delete_Attornery: "attorney/delete-attorney/{id}",
    referal_request_list: "referal/get-referal-request",
    retrun_to_main_account: "referal/return-main-account",
    Watch_ReferalPackages: "referal/packages",
    accept_request: "referal/accept-referal",
    reject_request: "referal/reject-referal",
    get_PhonePrefix: "mobile-prefixes",
    get_innovations: "yenilikler",
    get_slider: "sliders",
    get_DangerousPackages: "dangerous-goods",
    get_singleNews: "{category}/{slug}",
    pay_packages_bank: "packages/package-bulk-pay-card",
    check_callback: "check-callback",
    get_CourierDetail: "courier/show-order-details?order_id={id}",
    get_referalList: "referal/packages",
    get_calculatorCountry: "calculator",
    get_notificationById: "read-notification/{id}",
    get_siteTranslationData: "translations",
    post_trackSearch: "check-order",
    get_popUp: "popup",
    post_sendMail: "send-mail",
    check_status: "popup/check-status",
    popup_close: "popup/close",
    get_yp_cities: "courier/yp/yp-cities",
    get_yp_branches: "courier/yp/yp-branches/{city_id}",
    post_YpOrders: "courier/yp/yp-create-order",
    get_YpOrder: "courier/yp/yp-orders",
    post_yp_delivery: "courier/yp/calculate",
    // Corporate
    get_corporate: "corporate",
    service_page: "service-page",
    // Bank Cards
    get_bank_cards: "bank-cards/get-cards",
    add_bank_card: "bank-cards/add",
    delete_bank_card: "bank-cards/delete/{id}",
    // Special Order
    special_order_countries: "special-order/countries",
    special_order_get_orders: "special-order/{country_id}/get/orders",
    special_order_add: "special-order/{country_id}/add",
    special_order_pay: "special-order/{country_id}/pay/{order_id}",
    special_order_get_update: "special-order/{country_id}/get/update/{order_id}",
    special_order_update: "special-order/{country_id}/update/{order_id}",
    special_order_update_partner: "special-order/{country_id}/update-partner/{order_id}",
    special_order_cancel_partner: "special-order/{country_id}/cancel-partner/{order_id}",
    special_order_delete: "special-order/{country_id}/delete/{order_id}",
    special_order_show: "special-order/{country_id}/show-orders",
    special_order_calculate: "special-order/{country_id}/calculate",
    special_order_settings: "special-order/{country_id}/settings",
    special_order_balance: "special-order/balance",
    special_order_balance_logs: "special-order/balance/logs",
    // Package service fee preview
    packages_service_fee: "packages/service-fee",
    // Service debts
    user_debt_status: "user/debt-status",
    service_debts: "service-debts",
    service_debts_summary: "service-debts/summary",
    service_debts_pay_balance: "service-debts/pay/balance",
    service_debts_pay_card: "service-debts/pay/card",
    service_debts_pay_direct: "service-debts/pay/direct",
  };
  if (typeof services[service] === "string") {
    services[service] = { path: String(services[service]) };
  }

  let url = services[service].path;
  if (params) {
    let query_params: { [key: string]: any } = {};
    let has_query_params = false;

    for (const [key, value] of Object.entries(params)) {
      let replaced = false;
      url = url.replaceAll("{" + key + "}", () => {
        replaced = true;
        return value;
      });
      if (!replaced) {
        has_query_params = true;
        query_params[key] = value;
      }
    }

    if (has_query_params) {
      let param = new URLSearchParams(query_params);
      url += "?" + param.toString();
    }
  }
  return url;
};

export { $api };
